import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "operationForm",
        onSubmit: _ctx.editOperation,
        "validation-schema": _ctx.operationSchema,
        "initial-values": _ctx.operationForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Casier "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "casier" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.casierOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "casier",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Colis "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "colis" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.colisOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "colis",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Modifier l' opération ", -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-operations",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}